import type { AxiosResponseHeaders } from "axios";

export type LinkPagination = {
  next?: number;
  prev?: number;
  first?: number;
  last?: number;
  count?: number;
};

function asString(header: unknown): string | undefined {
  if (!header) return undefined;
  if (typeof header === "string") return header;
  if (typeof (header as AxiosResponseHeaders).get === "function") {
    return (
      ((header as AxiosResponseHeaders).get("Link") as string | undefined) ??
      undefined
    );
  }
  return undefined;
}

// LinkHeaderPagination: la lista es plana y la paginación vive en el HTTP Link header.
// Ej: <url?page=2>; rel="next", <url?page=1>; rel="prev"
export function parseLinkHeader(header?: unknown): LinkPagination {
  const raw = asString(header);
  if (!raw) return {};
  const result: LinkPagination = {};
  const entries = raw.split(",");
  for (const entry of entries) {
    const match = entry.match(/<([^>]+)>;\s*rel="(\w+)"/);
    if (!match) continue;
    const url = match[1];
    const rel = match[2];
    const pageMatch = url.match(/[?&]page=(\d+)/);
    if (pageMatch) {
      const page = Number(pageMatch[1]);
      if (rel === "next") result.next = page;
      else if (rel === "prev") result.prev = page;
      else if (rel === "first") result.first = page;
      else if (rel === "last") result.last = page;
    }
  }
  const countMatch = raw.match(/count=(\d+)/);
  if (countMatch) {
    result.count = Number(countMatch[1]);
  }
  return result;
}
